import buildHistoryTransactionObj from "../../moneyBuilder/investments/objects/build_history_transaction_obj";
import { rollBackwardDate } from "./roll_backward_date_function";

export const checkForDividendPayouts = (summaryTranArr, beginTransNbr, currentGameDate) => {
    
    let transNbr = beginTransNbr;
    let historyArr = [];
    let checkGameDate = JSON.parse(JSON.stringify(currentGameDate));
    //  investment must have been bought more than 1 month before the currentGameDate
    checkGameDate = rollBackwardDate(checkGameDate, 1);
           
    for (let i=0; i<summaryTranArr.length; i++){
        const transaction = summaryTranArr[i];
        if (transaction.firstBuyDate < checkGameDate){
            const dividendYield = summaryTranArr[i].yield;
            const currentPrice = summaryTranArr[i].currentPrice;
            const dividendPerShare = ((dividendYield * currentPrice) / 4).toFixed(2);
            const dividendAmt = dividendPerShare * +transaction.quantity;
            transNbr +=1;
            const tranInfo = {investShortName: summaryTranArr[i].investShortName, tranType: "dividend",  
                sellPrice: dividendPerShare, dateClosed: currentGameDate, quantity: transaction.quantity,  
                sellAmount: dividendAmt, totalGainLoss: dividendAmt,
                transNbr: transNbr, investmentName: summaryTranArr[i].investmentName}
            const transactionObj = buildHistoryTransactionObj(tranInfo);
            historyArr.push(transactionObj);
        }
    }
    return historyArr;
}
    
export default checkForDividendPayouts;